import React from "react";
import { useTranslation } from "react-i18next";
import Carousel from 'react-bootstrap/Carousel';

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    const imgCarousel = [
        {
            path: "/assets/images/altrePag/carrara.jpg",
            alt: t('aboutUsPage.altImg1')
        },
        {
            path: "/assets/images/altrePag/interno1.jpg",
            alt: t('aboutUsPage.altImg2')
        },
        {
            path: "/assets/images/altrePag/locandina.jpg",
            alt: t('aboutUsPage.altImg3')
        }
    ]

    return (
        <section>
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
            <div className="row align-items-center justify-content-center">
                <div className="col-12 col-lg-7">
                    <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.subTitle1') as string }} />
                    <ul className="mb-4">
                        <li>
                            <h3>{t('aboutUsPage.liTitle1')}</h3>
                            <p>{t('aboutUsPage.liPara1')}</p>
                        </li>
                        <li>
                            <h3>{t('aboutUsPage.liTitle2')}</h3>
                            <p>{t('aboutUsPage.liPara2')}</p>
                        </li>
                    </ul>
                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
                </div>
                <div className="col-12 col-sm-10 col-lg-5" id="about-us-carousel">
                    <Carousel fade>
                        {imgCarousel.map((item, index) => (
                            <Carousel.Item key={index}>
                                <img src={item.path} alt={`${item.alt}`} className="img-fluid" />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    )
};
export default AboutUsMain;